import { useTranslation } from 'react-i18next';
import Tag from '@/components/ui/custom/dataDisplay/Tag';
import { CourseFormatEnum } from '@/models/Course';

export type Props = {
  formats?: CourseFormatEnum[];
  className?: string;
};

function CoursePathCardFormats(props: Props) {
  const { formats } = props;

  const [tFormats] = useTranslation('translation', {
    keyPrefix: 'courseFormats',
  });

  if (!formats?.length) return null;

  const formatsColors: Record<
    CourseFormatEnum,
    'primary' | 'success' | 'warning' | 'info' | 'accent'
  > = {
    IN_PERSON: 'primary',
    ONLINE: 'primary',
    SCHOOL: 'primary',
    EXTRA_COURSE: 'info',
    SELF_PACED: 'info',
  };
  const getFormatColor = (format: CourseFormatEnum) => {
    return formatsColors[format] || 'primary';
  };

  return (
    <div className="flex gap-1 flex-wrap">
      {formats.map(format => (
        <Tag
          key={format}
          className={{
            base: 'py-0 px-1.5 h-5 border',
            text: 'text-[0.75rem] text-nowrap font-400 pt-0',
          }}
          color={getFormatColor(format)}
          text={tFormats(format)}
        />
      ))}
    </div>
  );
}

export default CoursePathCardFormats;
